import React from 'react';
import {
  AcademicCapIcon,
  BookOpenIcon,
  BriefcaseIcon,
  BuildingOffice2Icon,
  ChatBubbleLeftRightIcon,
  DocumentTextIcon,
  NewspaperIcon,
  PlayCircleIcon,
  UserCircleIcon,
} from '@heroicons/react-v2/24/solid';

import {cx} from '../../util';

// Canonical display order for each filterable content type.
export const TYPE_ORDER = [
  'company',
  'role',
  'course',
  'lesson',
  'guide',
  'question',
  'coach',
  'resource',
  'blog',
];

export const TYPE_LABELS = {
  company: 'Companies',
  role: 'Roles',
  course: 'Courses',
  lesson: 'Lessons',
  resource: 'Resources',
  question: 'Interview Questions',
  coach: 'Coaching',
  blog: 'Blog',
  guide: 'Guides',
};

export const TYPE_ICONS = {
  company: BuildingOffice2Icon,
  role: BriefcaseIcon,
  course: AcademicCapIcon,
  lesson: PlayCircleIcon,
  resource: DocumentTextIcon,
  question: ChatBubbleLeftRightIcon,
  coach: UserCircleIcon,
  blog: NewspaperIcon,
  guide: BookOpenIcon,
};

// Tinted background + icon color per content type.
export const TYPE_COLORS = {
  company: 'bg-gray-100 text-gray-500',
  role: 'bg-teal-50 text-teal-600',
  course: 'bg-indigo-50 text-indigo-600',
  lesson: 'bg-violet-50 text-violet-600',
  resource: 'bg-amber-50 text-amber-600',
  question: 'bg-sky-50 text-sky-600',
  coach: 'bg-emerald-50 text-emerald-600',
  blog: 'bg-orange-50 text-orange-600',
  guide: 'bg-fuchsia-50 text-fuchsia-600',
};

export const ResultIcon = ({type, image, className}) => {
  const Icon = TYPE_ICONS[type];
  return (
    <div
      className={cx(
        'flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-lg',
        image ? 'bg-gray-100 text-gray-500' : TYPE_COLORS[type],
        className,
      )}
    >
      {image
        ? <img src={image} className="h-6 w-6 object-contain" alt="" loading="lazy" />
        : Icon && <Icon className="h-5 w-5" />}
    </div>
  );
};
